/* ==========================================================================
   CınCık — kişiselleştirme davranışı
   · Fotoğraf: native <input type=file name="properties[...]">. Tema ATC'yi
     FormData ile POST ettiği (ve Content-Type'i sildiği) için dosya
     kendiliğinden siparişe gider — ek uygulama gerekmez.
   · Ücretli ekler fiyat taşıyamaz (property fiyatı değiştirmez), bu yüzden
     ayrı ürün satırı olarak /cart/add.js ile eklenir.
   ========================================================================== */
(function () {
  'use strict';

  function money(tl) { return Number(tl).toFixed(2) + 'TL'; }

  function bytes(n) {
    if (n < 1024) return n + ' B';
    if (n < 1048576) return (n / 1024).toFixed(0) + ' KB';
    return (n / 1048576).toFixed(1) + ' MB';
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart/add.js';
  }

  class CincikPersonalization extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.form = this.findForm();
      this.fileInput = this.querySelector('[data-ck-file]');
      this.drop = this.querySelector('[data-ck-drop]');
      this.nameInput = this.querySelector('[data-ck-name-input]');
      this.photoRequired = this.dataset.photoRequired === 'true';
      this.nameRequired = this.dataset.nameRequired === 'true';
      this.maxBytes = (parseInt(this.dataset.maxMb, 10) || 12) * 1048576;

      this.bindFormAssociation();
      this.bindPhoto();
      this.bindName();
      this.bindPaidText();
      this.bindToggle('[data-ck-note-toggle]', '[data-ck-note-panel]', '[data-ck-note-input]');
      this.bindGift();
      this.bindChain();
      this.bindBox();
      this.bindShape();
      // Baslangicta kapali olan tum opsiyonel alanlari forma sokma
      var self = this;
      this.querySelectorAll('[data-ck-paid-input], [data-ck-note-input]').forEach(function (el) {
        if (el.disabled) self.setActive(el, false);
      });
      this.bindAddToCart();
      this.updateSummary();
    }

    /* Panel formun DIŞINDA durabilir; HTML5 form="" ile bağlarız,
       böylece FormData(form) alanları toplar. */
    findForm() {
      var scope = this.closest('.shopify-section') || document;
      var form = scope.querySelector('form[data-type="add-to-cart-form"]') ||
                 document.querySelector('form[data-type="add-to-cart-form"]');
      // DİKKAT: formda name="id" (varyant) input'u var; form.id ONU dondurur.
      // Her zaman getAttribute/setAttribute kullan.
      if (form && !form.getAttribute('id')) {
        form.setAttribute('id', 'ck-product-form-' + (this.dataset.section || '1'));
      }
      return form;
    }

    formId() {
      return this.form ? this.form.getAttribute('id') : null;
    }

    bindFormAssociation() {
      var id = this.formId();
      if (!id) return;
      this.querySelectorAll('input[name^="properties"], textarea[name^="properties"]')
        .forEach(function (el) { el.setAttribute('form', id); });
    }

    /* Kapali alan forma HIC girmesin: tema property'leri isimden tarayip
       kopyaladigi icin sadece disabled yetmiyor, name'i de kaldiriyoruz. */
    setActive(el, active) {
      if (!el) return;
      if (active) {
        el.disabled = false;
        if (el.dataset.ckName) { el.setAttribute('name', el.dataset.ckName); delete el.dataset.ckName; }
      } else {
        el.disabled = true;
        el.value = '';
        var n = el.getAttribute('name');
        if (n) { el.dataset.ckName = n; el.removeAttribute('name'); }
      }
    }

    /* ---------------- fotoğraf ---------------- */
    bindPhoto() {
      if (!this.fileInput || !this.drop) return;
      var self = this;
      var idle = this.querySelector('[data-ck-idle]');
      var done = this.querySelector('[data-ck-done]');
      var img = this.querySelector('[data-ck-preview]');
      var nameEl = this.querySelector('[data-ck-filename]');
      var sizeEl = this.querySelector('[data-ck-filesize]');
      var err = this.querySelector('[data-ck-photo-err]');
      var change = this.querySelector('[data-ck-change]');

      // Dosya yokken boş property göndermeyelim.
      this.fileInput.disabled = true;

      function fail(msg) {
        err.textContent = msg; err.hidden = false;
        self.drop.classList.add('has-error');
        self.setActive(self.fileInput, false);
        idle.hidden = false; done.hidden = true;
        self.drop.classList.remove('is-filled');
      }

      function accept(file) {
        if (!/^image\//.test(file.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) {
          return fail('Sadece fotoğraf yükleyebilirsin (JPG, PNG, WEBP, HEIC).');
        }
        if (file.size > self.maxBytes) {
          return fail('Dosya çok büyük (' + bytes(file.size) + '). En fazla ' + self.dataset.maxMb + ' MB.');
        }
        err.hidden = true;
        self.drop.classList.remove('has-error');
        self.drop.classList.add('is-filled');
        self.setActive(self.fileInput, true);
        idle.hidden = true; done.hidden = false;
        nameEl.textContent = file.name;
        sizeEl.textContent = bytes(file.size);
        if (/^image\/(png|jpe?g|webp)$/i.test(file.type)) {
          var r = new FileReader();
          r.onload = function (e) { img.src = e.target.result; };
          r.readAsDataURL(file);
        } else {
          img.removeAttribute('src');
        }
      }

      this.fileInput.addEventListener('change', function () {
        if (this.files && this.files[0]) accept(this.files[0]);
      });

      ['dragenter', 'dragover'].forEach(function (t) {
        self.drop.addEventListener(t, function (e) { e.preventDefault(); self.drop.classList.add('is-dragging'); });
      });
      ['dragleave', 'drop'].forEach(function (t) {
        self.drop.addEventListener(t, function (e) { e.preventDefault(); self.drop.classList.remove('is-dragging'); });
      });
      this.drop.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!f) return;
        try {
          var dt = new DataTransfer(); dt.items.add(f);
          self.fileInput.files = dt.files;
        } catch (_) {}
        accept(f);
      });

      if (change) {
        change.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          self.setActive(self.fileInput, true);
          self.fileInput.click();
        });
      }
    }

    /* ---------------- ücretsiz isim ---------------- */
    bindName() {
      var i = this.nameInput;
      if (!i) return;
      var c = this.querySelector('[data-ck-name-count]');
      var err = this.querySelector('[data-ck-name-err]');
      i.addEventListener('input', function () {
        if (c) c.textContent = i.value.length;
        if (i.value.trim() && err) { err.hidden = true; i.classList.remove('has-error'); }
      });
    }

    /* ---------------- ücretli arka yazı ---------------- */
    bindPaidText() {
      var t = this.querySelector('[data-ck-paid-toggle]');
      var p = this.querySelector('[data-ck-paid-panel]');
      var i = this.querySelector('[data-ck-paid-input]');
      var c = this.querySelector('[data-ck-paid-count]');
      if (!t || !p || !i) return;
      var self = this;
      t.addEventListener('change', function () {
        p.hidden = !t.checked;
        self.setActive(i, t.checked);
        if (t.checked) setTimeout(function () { i.focus(); }, 30);
        self.updateSummary();
      });
      i.addEventListener('input', function () { if (c) c.textContent = i.value.length; });
    }

    bindToggle(toggleSel, panelSel, inputSel) {
      var t = this.querySelector(toggleSel);
      var p = this.querySelector(panelSel);
      var i = this.querySelector(inputSel);
      if (!t || !p || !i) return;
      var self = this;
      t.addEventListener('change', function () {
        p.hidden = !t.checked;
        self.setActive(i, t.checked);
      });
    }

    bindGift() {
      var g = this.querySelector('[data-ck-gift-toggle]');
      if (!g) return;
      var self = this;
      g.addEventListener('change', function () { self.updateSummary(); });
    }

    /* Zincir: radyo grubu. Ucretsiz secenegin varyant ID'si bos olur ve
       sepete ek satir eklenmez; secilen zincirin adi her halukarda
       properties[Zincir] olarak siparise gider. */
    bindChain() {
      var radios = this.querySelectorAll('[data-ck-chain]');
      if (!radios.length) return;
      var self = this;
      radios.forEach(function (r) {
        r.addEventListener('change', function () { self.updateSummary(); });
      });
    }

    chosenChain() {
      return this.querySelector('[data-ck-chain]:checked');
    }

    /* Kutu: zincirle ayni radyo mantigi. "Isimli" varyant secilince
       (data-needs-name) isim alani acilir ve zorunlu olur. */
    bindBox() {
      var radios = this.querySelectorAll('[data-ck-box]');
      if (!radios.length) return;
      var self = this;
      var panel = this.querySelector('[data-ck-box-name-panel]');
      var input = this.querySelector('[data-ck-box-name-input]');
      var count = this.querySelector('[data-ck-box-name-count]');
      var sync = function () {
        var need = self.boxNeedsName();
        if (panel) panel.hidden = !need;
        self.setActive(input, need);
        self.updateSummary();
      };
      radios.forEach(function (r) { r.addEventListener('change', sync); });
      if (input) {
        input.addEventListener('input', function () {
          if (count) count.textContent = input.value.length;
          input.classList.remove('has-error');
          var er = self.querySelector('[data-ck-box-name-err]');
          if (er) er.hidden = true;
        });
      }
      sync();
    }

    chosenBox() {
      return this.querySelector('[data-ck-box]:checked');
    }

    boxNeedsName() {
      var b = this.chosenBox();
      return !!(b && b.dataset.needsName === 'true');
    }

    bindShape() {
      var self = this;
      this.querySelectorAll('[data-ck-shape-opt]').forEach(function (r) {
        r.addEventListener('change', function () {
          var er = self.querySelector('[data-ck-shape-err]');
          if (er) er.hidden = true;
        });
      });
    }

    /* Panelde radyo secimi varsa (zincir/sekil/kutu) sepete eklemeyi biz
       yapariz: Kaching property'leri .value ile okuyor, radyo grubunda
       secili olmayan degerleri de alabilir. FormData yalniz secileni alir. */
    hasChoices() {
      return !!this.querySelector('[data-ck-chain]:checked, [data-ck-box]:checked, [data-ck-shape-opt]:checked');
    }

    /* ---------------- ek tutar ---------------- */
    extras() {
      var list = [];
      var p = this.querySelector('[data-ck-paid-toggle]');
      var g = this.querySelector('[data-ck-gift-toggle]');
      if (p && p.checked && this.dataset.paidVariant) {
        list.push({ id: this.dataset.paidVariant, price: Number(this.dataset.paidPrice || 0) });
      }
      if (g && g.checked && this.dataset.giftVariant) {
        list.push({ id: this.dataset.giftVariant, price: Number(this.dataset.giftPrice || 0) });
      }
      var c = this.chosenChain();
      if (c && c.dataset.variant && Number(c.dataset.price) > 0) {
        list.push({ id: c.dataset.variant, price: Number(c.dataset.price) });
      }
      var bx = this.chosenBox();
      if (bx && bx.dataset.variant && Number(bx.dataset.price) > 0) {
        list.push({ id: bx.dataset.variant, price: Number(bx.dataset.price) });
      }
      return list;
    }

    updateSummary() {
      var box = this.querySelector('[data-ck-sum]');
      var val = this.querySelector('[data-ck-sum-val]');
      if (!box || !val) return;
      var total = this.extras().reduce(function (s, e) { return s + e.price; }, 0);
      if (total > 0) { val.textContent = '+' + money(total); box.hidden = false; }
      else box.hidden = true;
    }

    /* ---------------- doğrulama ---------------- */
    firstProblem() {
      if (this.photoRequired && this.fileInput &&
          !(this.fileInput.files && this.fileInput.files.length)) {
        return { type: 'photo', msg: this.dataset.photoError || 'Önce fotoğrafını yükle' };
      }
      if (this.nameRequired && this.nameInput && !this.nameInput.value.trim()) {
        return { type: 'name', msg: this.dataset.nameError || 'Kazınacak ismi yaz' };
      }
      if (this.querySelector('[data-ck-shape-opt]') && !this.querySelector('[data-ck-shape-opt]:checked')) {
        return { type: 'shape', msg: this.dataset.shapeError || 'Kolye şeklini seç' };
      }
      var bn = this.querySelector('[data-ck-box-name-input]');
      if (this.boxNeedsName() && bn && !bn.value.trim()) {
        return { type: 'boxname', msg: this.dataset.boxNameError || 'Kutuya yazılacak ismi yaz' };
      }
      return null;
    }

    showProblem(problem, btn) {
      if (problem.type === 'photo') {
        var pe = this.querySelector('[data-ck-photo-err]');
        if (pe) { pe.textContent = problem.msg; pe.hidden = false; }
        if (this.drop) this.drop.classList.add('has-error');
      } else if (problem.type === 'shape' || problem.type === 'boxname') {
        var er = this.querySelector(problem.type === 'shape' ? '[data-ck-shape-err]' : '[data-ck-box-name-err]');
        if (er) { er.textContent = problem.msg; er.hidden = false; }
        var bi = problem.type === 'boxname' && this.querySelector('[data-ck-box-name-input]');
        if (bi) { bi.classList.add('has-error'); bi.focus(); }
      } else {
        var ne = this.querySelector('[data-ck-name-err]');
        if (ne) { ne.textContent = problem.msg; ne.hidden = false; }
        if (this.nameInput) { this.nameInput.classList.add('has-error'); this.nameInput.focus(); }
      }
      var label = btn && btn.querySelector('.main-atc__label__text');
      if (label && !btn.dataset.ckOldLabel) {
        btn.dataset.ckOldLabel = label.textContent;
        label.textContent = problem.msg;
        setTimeout(function () {
          if (btn.dataset.ckOldLabel) { label.textContent = btn.dataset.ckOldLabel; delete btn.dataset.ckOldLabel; }
        }, 2600);
      }
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* ---------------- sepete ekleme ----------------
       Kaching Bundles ATC'yi devraliyor ve property'leri .value ile okuyor.
       Dosya input'unda .value = "C:\\fakepath\\..." oldugu icin fotograf
       KAYBOLUYOR. Bu yuzden dosya varken sepete eklemeyi biz yapiyoruz:
       formu oldugu gibi multipart POST edince Shopify dosyayi barindirip
       property'ye gercek CDN adresini yaziyor. Kaching'in gizli alani
       (__kaching_bundles) formda oldugu icin paket bilgisi de korunuyor. */

    hasFile() {
      return !!(this.fileInput && this.fileInput.files && this.fileInput.files.length);
    }

    root() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return r.replace(/\/$/, '');
    }

    async addMain() {
      var fd = new FormData(this.form);
      var res = await fetch(this.root() + '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd                       // Content-Type ELLE VERILMEZ -> tarayici multipart kurar
      });
      var json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Sepete eklenemedi');
      return json;
    }

    /* Zincir/kutu her urun icin: "2 Adet" paketinde 2 zincir, 2 kutu. */
    mainQty() {
      var q = this.form && this.form.querySelector('[name="quantity"]');
      var n = parseInt(q && q.value, 10);
      return n > 0 ? n : 1;
    }

    async addExtras(extras) {
      if (!extras.length) return;
      var qty = this.mainQty();
      await fetch(this.root() + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: extras.map(function (x) { return { id: Number(x.id), quantity: qty }; }) })
      });
    }

    async refreshCart() {
      var drawer = document.querySelector('cart-drawer');
      try {
        var res = await fetch(this.root() + '/?sections=cart-drawer,cart-icon-bubble');
        var sections = await res.json();
        var parse = function (html, sel) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector(sel);
          return el ? el.innerHTML : null;
        };
        if (sections['cart-drawer']) {
          var inner = parse(sections['cart-drawer'], '.drawer__inner');
          var target = document.querySelector('#CartDrawer .drawer__inner');
          if (inner !== null && target) target.innerHTML = inner;
          if (drawer) drawer.classList.remove('is-empty');
        }
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var b = parse(sections['cart-icon-bubble'], '.shopify-section') || sections['cart-icon-bubble'];
          if (bubble) bubble.innerHTML = b;
        }
      } catch (e) { /* bolum yenilenemezse asagida sepete yonlendiririz */ }

      if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
      if (drawer) { drawer.classList.add('active'); document.body.classList.add('overflow-hidden'); return true; }
      return false;
    }

    async runAdd(btn) {
      var self = this;
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        await self.addMain();
        await self.addExtras(self.extras());
        var opened = await self.refreshCart();
        if (!opened) window.location.href = self.root() + '/cart';
      } catch (e) {
        var msg = (e && e.message) || 'Sepete eklenemedi, tekrar dener misin?';
        var pe = self.querySelector('[data-ck-photo-err]');
        if (pe) { pe.textContent = msg; pe.hidden = false; }
      } finally {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
      }
    }

    bindAddToCart() {
      var self = this;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('button[name="add"], .atc-button, .main-product-atc');
        if (!btn || !self.ownsButton(btn)) return;

        var problem = self.firstProblem();
        if (problem) {
          e.preventDefault(); e.stopImmediatePropagation();
          self.showProblem(problem, btn);
          return;
        }

        // Dosya ya da ucretli ek yoksa temanin kendi akisi calissin.
        if (!self.hasFile() && !self.extras().length && !self.hasChoices()) return;

        e.preventDefault(); e.stopImmediatePropagation();
        self.runAdd(btn);
      }, true); // capture: tema ve uygulama dinleyicilerinden ONCE
    }

    ownsButton(btn) {
      if (this.form && btn.form === this.form) return true;
      var sec = this.closest('.shopify-section');
      if (sec && sec.contains(btn)) return true;
      if (btn.closest('sticky-atc, .sticky-atc, [class*="sticky-atc"]')) return true;
      return false;
    }
  }

  if (!customElements.get('cincik-personalization')) {
    customElements.define('cincik-personalization', CincikPersonalization);
  }
})();

/* CK-BLOCK: lightbox+bundle */
/* ==========================================================================
   Fotoğraflı yorum — fotoğraf büyütme
   ========================================================================== */
(function () {
  'use strict';
  var dlg = null;

  function ensure() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'ck-lb';
    dlg.innerHTML = '<button type="button" class="ck-lb__close" aria-label="Kapat">&times;</button><img alt="">';
    document.body.appendChild(dlg);
    dlg.querySelector('.ck-lb__close').addEventListener('click', function () { dlg.close(); });
    // arka plana tiklayinca kapansin
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    return dlg;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ck-lightbox]');
    if (!btn) return;
    var src = btn.querySelector('img');
    if (!src) return;
    var d = ensure();
    var big = d.querySelector('img');
    big.src = src.currentSrc || src.src;
    big.alt = src.alt || '';
    if (typeof d.showModal === 'function') d.showModal();
  });
})();

/* ==========================================================================
   Mobilde Kaching paket teklifini yukarı al

   Kaching kendini SEPETE EKLE'nin hemen ustune enjekte ediyor; telefonda
   kisisellestirme panelinin de altinda kaldigi icin teklif goruinmuyordu.
   Sadece <750px'te ve sadece BIR KEZ tasiyoruz; parcalardan biri yoksa
   hicbir sey yapmiyoruz (sessiz basarisizlik, layout bozulmaz).
   ========================================================================== */
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';
  var moved = false;

  function move() {
    if (moved || !window.matchMedia(MOBILE).matches) return;
    var bundle = document.querySelector('kaching-bundles-block') ||
                 document.querySelector('.kaching-bundles');
    if (!bundle) return;
    var info = document.querySelector('.product__info-container');
    if (!info || !info.contains(bundle)) return;

    // Panelin ustune: kisisellestirme varsa onun oncesine, yoksa fiyattan sonra.
    var anchor = info.querySelector('cincik-personalization') ||
                 info.querySelector('.product-page-price');
    if (!anchor) return;
    if (anchor.tagName === 'CINCIK-PERSONALIZATION') {
      anchor.parentNode.insertBefore(bundle, anchor);
    } else {
      anchor.parentNode.insertBefore(bundle, anchor.nextSibling);
    }
    moved = true;
  }

  function watch() {
    move();
    if (moved) return;
    // Kaching gec render ediyor; kisa sureli gozle, sonra birak.
    var obs = new MutationObserver(function () { move(); if (moved) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else { watch(); }
})();
